export default {
  title: "Client List",
  allClients: "All Clients",
  internalClients: "Internal",
  internalClient: "Internal",
  externalClients: "External",
  externalClient: "External",
  clientsType: "Client Type",

  noEnitity: {
    label: "Page Unavailable",
    text: "Your legal entity is under moderation",
  },
  needBuyTariff: "You need to purchase a tariff to digitize clients",
  noTradingPoint: "You don't have any trading points yet",
  digitizeClients: "Digitize clients so they appear in your list",

  table: {
    inviteDate: "Registration Date",
    fullName: "Full Name",
    phone: "Phone Number",
    receiptsCount: "Number of Purchases",
    receiptsSum: "Purchase Amount",
  },

  clientCard: {
    title: "Client Information",
    client: {
      title: "Client",
      fields: {
        fullName: "Full Name",
        gender: "Gender",
        birthDate: "Birth Date",
        phone: "Phone Number",
        clientType: "Client Type",
        inviteDate: "Registration Date",
        regSource: "Registration Source",
        rcCard: "RC Card Number",
        note: "Note",
      },
      phoneHint:
        "Phone number is displayed only on paid tariffs and only for clients who have given their consent to share contact details and receive marketing offers.",
    },
    statistic: {
      title: "Statistics",
      block: {
        avgReceiptsSum: "Average Receipt",
        receiptsCount: "Number of Purchases",
        receiptsSum: "Revenue",
        writeOffPointsSum: "Payment with Points",
      },
      totalNumberOfVisit: "Total Number of Visits",
      firstVisit: "First Visit",
      lastVisit: "Last Visit",
      visitedShops: "Visited Establishments",
    },
    receipts: {
      title: "Receipts",
      emptyState: {
        title: "No Receipts",
        description:
          "They will appear here after <br> the client makes a purchase",
      },
    },
    reviews: {
      title: "Reviews",
      noReviews: "No reviews yet",
      itsAppearHere:
        "They will appear here when <br> the client leaves a review",
    },
  },
  pointsAwarded: "Points Awarded",
  digitizingOnYourTariffNotAvailable:
    "Client digitization is not available on your tariff",
  digitizingIntoRC: "Client digitization<br> via RC PAY",
  fastDigitizingIntoTg: "Fast digitization<br> via Telegram bot",
  abilityToUseLinkOrQRcode:
    "The ability to use a link or QR code to invite new users will become available after purchasing a tariff.",
  inviteClients: "Invite Clients",
  selectPointToGenerateQR:
    "Select a trading point to generate a link and&nbsp;QR&nbsp;code for&nbsp;registering new clients in&nbsp;RC&nbsp;PAY.",
  invitingtoLoyaltyProgram: "Invitation to Loyalty Program",
  downloadQR: "Download QR Code",
  linkCopied: "Link Copied",
  share: "Share",
  joinToLoyaltyProgram: "Join the Loyalty Program!",
  receiveDiscountNotifies:
    "Get notifications about discounts and exclusive promotions. We offer rewards for every purchase and payment with points up to 99.9%.",
  clientServiceAndAppRcPay:
    "Customer service rcpay.ru and RC PAY app - your guides to the world of profitable and comfortable shopping!",
};
